(function() {
    if (typeof window !== 'undefined') {
        var agGrid = require('ag-grid-community');

        window.agGrid = agGrid;
    }
})();
